import { render, staticRenderFns } from "./PredictiveSection.vue?vue&type=template&id=4cb80820&scoped=true"
import script from "./PredictiveSection.vue?vue&type=script&lang=js"
export * from "./PredictiveSection.vue?vue&type=script&lang=js"
import style0 from "./PredictiveSection.vue?vue&type=style&index=0&id=4cb80820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb80820",
  null
  
)

export default component.exports